// src/components/CalledBallsModal.js
import React from 'react';
import CalledBallsDisplay from './CalledBallsDisplay';
import './CalledBallsModal.css';

function CalledBallsModal({ drawnNumbers, onClose }) {
  return (
    <div className="called-balls-modal-overlay" onClick={onClose}>
      <div className="called-balls-modal-content" onClick={(e) => e.stopPropagation()}>
        {/* Pass the drawnNumbers (which is a Set) to CalledBallsDisplay */}
        <CalledBallsDisplay drawnNumbers={drawnNumbers} className="modal-inner-called-balls" />
        <button onClick={onClose} className="close-called-balls-modal-button">
          Close
        </button>
      </div>
    </div>
  );
}

export default CalledBallsModal;
